import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [匿名匹配记录接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=164426866
export const matchRecordHomepage = createAsyncThunk(
  'Saada/live/hiya_socialize/anonymous_matching_record_list',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/anonymous_matching_record_list',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  matchRecord?: Partial<any>
}

const initialState: InitialStateType = {
  matchRecord: {},
}

export const AnonymousMatchingSlice = createSlice({
  name: 'AnonymousMatching',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(matchRecordHomepage.fulfilled, (state, action) => {
      Object.assign(state, {matchRecord: action.payload})
    })
  },
})
export default AnonymousMatchingSlice.reducer
export const AnonymousMatchingActions = AnonymousMatchingSlice.actions

export const useAnonymousMatchingState = () => {
  const data = useSelector((state) => {
    return state.Animal_Chameleon
  })
  return data
}
